import { $, $$ } from 'utils/dom';

const newsTeasers = $$('.teaser-image-grid');

const handleItemAndButtonDisplay = (teaser, itemsToDisplay) => {
  const teaserItems = $$('li', teaser);
  teaserItems.forEach((item, index) => {
    if (index > itemsToDisplay - 1) {
      item.style.display = 'none';
    }
  });

  const loadMoreWrapper = $('.teaser-image-grid__button', teaser);

  if (teaserItems.length <= itemsToDisplay && loadMoreWrapper) {
    loadMoreWrapper.setAttribute('style', 'display: none');
  }

  const loadMoreButton = $('.btn', teaser);

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      teaserItems.forEach((item, index) => {
        if (index > itemsToDisplay - 1) {
          item.style.display = 'block';
        }
      });
      loadMoreButton.setAttribute('disabled', 'disabled');
    });
  }
};

newsTeasers.length &&
  newsTeasers.forEach(teaser => {
    if (teaser.classList.contains('teaser-image-grid--two-col')) {
      handleItemAndButtonDisplay(teaser, 6);
    }

    if (teaser.classList.contains('teaser-image-grid--three-col')) {
      handleItemAndButtonDisplay(teaser, 9);
    }
  });
